<template>
  <vx-card no-shadow>
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <!--<vs-avatar v-bind:src="'data:image/jpg;base64,'+ this.$store.state.avatar" size="70px" class="mr-4 mb-4" />-->
      <vs-avatar v-bind:src="this.$store.state.avatar" size="70px" class="mr-4 mb-4" />

      <div v-if="!dataImg">
        <input
          type="file"
          class="hidden"
          ref="uploadImgInput"
          @change="updateCurrImg"
          accept="image/*"
          name="image"
        />
        <vs-button class="mr-4 mb-4" @click="$refs.uploadImgInput.click()">Trocar Foto</vs-button>
      </div>
      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-4 mb-4" :disabled="disableSubmit" @click="submitData()">Salvar</vs-button>
      </div>
    </div>

    <template v-if="dataImg">
      <!-- Image Container -->
      <div class="img-container w-64 mx-auto flex items-center justify-center">
        <img :src="dataImg" alt="img" class="responsive" />
      </div>

      <!-- Image upload Buttons -->
      <div class="modify-img flex justify-between mt-5">
        <input
          type="file"
          class="hidden"
          ref="updateImgInput"
          @change="updateCurrImg"
          accept="image/png, image/gif, image/jpeg, image/jpg"
        />
        <vs-button class="mr-4" type="flat" @click="$refs.updateImgInput.click()">Trocar Foto</vs-button>
        <vs-button type="flat" color="#999" @click="dataImg = null">Remover Foto</vs-button>
      </div>
    </template>
  </vx-card>
</template> 

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { Validator } from "vee-validate";


const dict = {
  custom: {
    name: {
      required: "Por favor insira seu nome.",
      alpha: "Your first name may only contain alphabetic characters"
    }
  }
};
Validator.localize("en", dict);
export default {
  data() {
    return {
      file: "",
      dataImg: null,
      fileName: null,
      idUser: this.$store.state.user.idUser,
      userName: this.$store.state.user.userName ,
      disableSubmit: true
    };
  },
  computed:{
    isFormValid() {
      return !this.errors.any() && this.userName 
    }
  },
  methods: {
    async submitData() {
      try {
        this.$vs.loading();
        let user = {
          idUser: this.idUser,
          photoUser: this.dataImg,
          fileName : this.fileName
        };
        await axios.post(`${baseApiUrl}/avatar/save`, user);
        this.$store.dispatch("updateAvatar", this.idUser);
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        });
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar " + e,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }finally{
        this.dataImg = null;
        this.fileName = null;
        this.disableSubmit = true
      }
     
    },
    updateCurrImg(input) {
    this.disableSubmit =  false
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          this.dataImg = e.target.result;
          this.fileName = input.target.files[0].name
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    }
  }
};
</script>
